import styled from "@emotion/styled";

export const StyledFormicError = styled("p")(() => ({
  color: "red",
  padding: 0,
  margin: 0,
}));

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
